<template>
	<div class="main store-page noscroll">
		<div class="secondary-left-bar">
			<div>
				<h3>Developers</h3>
			</div>
			<div class="layout-column">
				<ul class="secondary-bar-items">
					<li>
						<router-link to="/developers/apps" class="item " >
							<inline-svg :src="require('@/assets/img/apps.svg')" />
							<span>Apps</span>
							<!--							<inline-svg class="lock" :src="require('@/assets/img/lock.svg')" />-->
						</router-link>
					</li>
					<li>
						<router-link to="/developers/logs" class="item locked" >
							<inline-svg :src="require('@/assets/img/logs.svg')" />
							<span>Logs
							</span>
							<span class="tag ">Coming soon</span>
<!--							<inline-svg class="lock" :src="require('@/assets/img/lock.svg')" />-->
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<div class="main-center funnel_steps_page apps_page noscroll layout-column">
			<div class=" noscroll">
				<router-view/>
			</div>
		</div>

	</div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";
import Loading from "@/components/Loading.vue";
import {mapGetters} from "vuex";
import API from "@/api";
import VSpinner from "@/components/base/v-spinner";
import VButton from "@/components/base/v-button";

export default {
	name: "Store",
	title: "Store | Funnelish™",
	components: {
		VButton,
		VSpinner,
		MainSearch,
		Loading,
	},
	mixins: [API],
	props: ["id"],
	data() {
		return {
			loading: true,
		};
	},
	computed: {
		...mapGetters(["ifError"]),
	},
	methods: {

	},
	mounted() {
	},
}
</script>

<style lang="scss" scoped>
.store-page {
	.item {
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
		.tag {
			right: -10px;
			position: absolute;
			background: whitesmoke;
			font-size: 12px;
			border-radius: 4px;
			padding: 3px 10px;
			text-align: center;
			font-weight: 400;
			color: $dark-grey;
		}
	}
}
</style>
